import axios from "axios";

export const api = axios.create({
    baseURL: "https://api.dashboard.musthost.com.br/api",
    timeout: 60000,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use(
    (config: any) => {
        const accessToken = localStorage.getItem("accessToken");
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error: unknown) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response: any) => {
        return response;
    },
    (error: any) => {
        if (error.response?.status === 401) {
            localStorage.clear();

            return;
        }
        return Promise.reject(error);
    }
);
